import React from 'react';

export default class HonorCardProductDetail extends React.Component {
	constructor(props) {
    	super(props);
	}

	render() {
		return (
			<div>
				<h3>Send an eCard</h3>
				<div className="ehonor-card-product-detail">
					<img className="product-image" src={ this.props.selectedProduct.image } />

					<p className="product-name">{ this.props.selectedProduct.valueText }</p>

				</div>
			</div>
		);
	}
}